module.exports = __webpack_public_path__ + "media/logos/BJP-logo-ebc72ebf.svg";